<main>
    <div class="double-column">
        <div>Opponent 1</div>
        <div>Opponent 2</div>

        <input type="text" id="username_one" bind:value={username_one}
            on:input={checkUserNameOne} on:click={setTabIndices} placeholder="bbo username one">

        <input type="text" id="username_two" bind:value={username_two}
            on:input={checkUserNameTwo} on:click={setTabIndices} placeholder="bbo username two">

        <input type="text" id="player_one" bind:value={player_one}
            on:input={playerInput} on:click={setTabIndices} placeholder="player's name one">

        <input type="text"  id="player_two" bind:value={player_two}
            on:input={playerInput} on:click={setTabIndices} placeholder="player's name two">
    </div>

    <div class="triple-column-center">
        <div>
            Allow pair deletion
            <input type="checkbox" tabindex="-1" on:click={deletePairAllowed} checked={delete_pairs}>
        </div>
        <button class="select-button" on:click={saveData}>Save</button>
        <button id="pair-delete-button" class="select-button" on:click={deletePair}>Delete</button>
    </div>

    <div class="pair-table">
        {#each pairs as pair, index (pair)}
            <div class=" pair {pair_class[index % 2]}"
                    class:pair-selected={pair === clicked_pair}
                    on:click={() => pairClicked(pair)}>
                <div>
                    <span class="pair-class">{pair[0]}</span>
                    <span>{pair[1]}</span>
                </div>
            </div>
        {/each}
    </div>
</main>

<style>
    .triple-column-center {
        display: grid;
        grid-template-columns: auto auto auto;
        justify-content: center;
        gap: 1vw;
    }

    .pair-class {
        display: inline-block;
        width: 12vw;
    }

    .double-column {
        display: grid;
        grid-template-columns: auto auto;
        justify-items: start;
        gap: 2vh;
    }

    .pair-table {
        border-style:solid;
        border-width: .25vh;
        padding: 1vh;
        height: 65vh;
        overflow: auto;
    }

    .pair {
        cursor: pointer;
        user-select: none;
        font-size: 1.85vh;
        font-weight: normal;
        padding-top: .2vh;
        padding-bottom: .3vh;
    }

    .pair-even  {
        color: darkgreen;
    }

    .pair-odd  {
        background-color: #efefe0;
        color: #444;
    }

    .pair-selected  {
        background-color: #ffffaa;
    }
    #pair-delete-button {
        visibility: hidden;
    }
</style>

<script>
    import { get } from 'svelte/store';
    import { user, state } from './data-store.js'
	import { createEventDispatcher } from 'svelte';
    import { buildMessage, switchGreetingValidation } from './common.js';
    import { writeToUser } from './user.js';
    import { elementVisibility, isUndefined } from './utilities.js';
	const dispatch = createEventDispatcher();

    // export let alpha;
    // $: xxx = alpha;
    $: pairs = getPairs($state.alpha, $user);
    $: dummy = checkPlayers($user.players);

    let player_one = '';
    let player_two = '';

    let delete_pairs = false
    let pair_class = ['pair-even', 'pair-odd'];
    let clicked_pair = ['', ''];
    let username_one = '';
    let username_two = '';

    function checkPlayers(players) {
        if (!isUndefined(players)) {
            if (Object.keys(players).length == 0) {
                username_one = '';
                username_two = '';
            };
            player_one = players[username_one];
            player_two = players[username_two];
        };
    };

    function getPairs() {
        let sorted_pairs = sortedPairs();
        let players = getPlayersByAlpha(sorted_pairs);
        return players;
    }
;
    function getPlayersByAlpha(sorted_pairs) {
        let pairs = [];
        let alpha = $state.alpha
        for (var pair of sorted_pairs) {
            let pair_comparator = pair[0].substr(0, alpha.length).toUpperCase();
            let alpha_comparator = alpha.toUpperCase();
            if (pair_comparator == alpha_comparator || alpha == 'All') {
                pairs.push(pair);
            }
        }
        return pairs
    }

    function sortedPairs() {
        let pairs = [];
        if (!isUndefined($user.pairs)) {
            for (var pair of $user.pairs) {
                pairs.push(pair);
                pairs.push([pair[1], pair[0]]);
            };
        };
        return pairs.sort();
    }

    function pairClicked(pair) {
        clicked_pair = pair;
        sort_names(pair);
        get(state).message = buildMessage()
        get(state).mode = 'g'
        switchGreetingValidation()
    }

    function playerInput() {
        // sendMessage()
        get(state).usernames = [username_one, username_two],
        get(state).first_names = [player_one, player_two]
        get(state).message = buildMessage()
    }

    function sort_names(pair) {
        // Randomize names
        let index_1 = Math.floor(Math.random() * 2);
        let other_indexes = [1, 0];
        let index_2 = other_indexes[index_1]
        let player_one = $user.players[pair[index_1]];
        let player_two = $user.players[pair[index_2]];

        username_one = pair[index_1];
        username_two = pair[index_2];

        get(state).usernames = [username_one, username_two]
        get(state).first_names = [player_one, player_two]
        checkPlayers($user.players)
    }

    function checkUserNameOne() {
        checkUsername(username_one)
    }

    function checkUserNameTwo() {
        checkUsername(username_two)
    }

    function checkUsername(username) {
        // Display pairs that match or the name if a full username
        if (username in $user.players) {
            let pair = [username_one, username_two]
            sort_names(pair);
            dispatch('message', {
                players: [player_one, player_two]
            });
        }
        // setTabIndices()
    }

    function setTabIndices() {
    //     let element = document.getElementById('username_one')
    //     username_one_index = getElementIndex(element)
    //     let u2 = document.getElementById('username_two')
    //     let p1 = document.getElementById('player_one')
    //     let p2 = document.getElementById('player_two')
    //     p1.tabIndex = username_one_index + 1
    //     u2.tabIndex = username_one_index + 2
    //     p2.tabIndex = username_one_index + 3
    //     username_two_index = username_one_index + 2
    //     player_one_index =  username_one_index + 1
    //     player_two_index =  username_one_index + 3
    }

    function getElementIndex(element) {
        return [...element.parentElement.children].indexOf(element);
    }

    function saveData() {
        if (validatePair(username_one, username_two, player_one, player_two)) {
            savePair(username_one, username_two)
            $user.players[username_one] = player_one
            $user.players[username_two] = player_two
            writeToUser();
        }
    }

    function validatePair(username_1, username_2, first_name_1, first_name_2) {
        // Validate a pair's data
        if (!username_1 || !username_2) {
            alert('Must provide a username.');
            return false;
        }
        if (!first_name_1 || !first_name_2) {
            alert('Must provide a first name.');
            return false;
        }
        if (username_1 == username_2) {
            alert('Must provide two user names');
            return false;
        }
        return true;
    }

    function savePair(username_one, username_two) {
        for (let pair of  $user.pairs) {
            let match_1 = (username_one == pair[0] && username_two == pair[1])
            let match_2 = (username_one == pair[1] && username_two == pair[0])
            if (match_1 || match_2) {
                return;
            }
        }
        $user.pairs.push([username_one, username_two])
        pairs = getPairs();
    }

    function deletePair() {
        if (!username_one || !username_two) {
            alert('Must provide a username.')
            return
        }
        if (!confirm('Are you sure you want to delete this pair?')) {
            return
        }
        var removed = removePairFromPairs();
        if (removed) {
            username_one = '';
            username_two = '';
            player_one = '';
            player_two = '';
            pairs = getPairs();
            writeToUser();
        }
    }

    function removePairFromPairs() {
        var removed = false;
        for (let index = 0; index < $user.pairs.length; index++) {
            let pair = $user.pairs[index];
            let comparator_even = getComparator(pair[0], pair[1]);
            let comparator_odd = getComparator(pair[1], pair[0]);
            removed = comparator_even || comparator_odd;
            if (removed) {
                $user.pairs.splice(index, 1);
                break;
            }
        }
        return removed
    }

    function getComparator(member_one, member_two) {
        let comparator_one = member_one == username_one;
        let comparator_two  = member_two == username_two;
        return comparator_one && comparator_two;
    }

    function deletePairAllowed() {
        delete_pairs = !delete_pairs;
        elementVisibility('pair-delete-button', 'hidden')
        if (delete_pairs) {
            elementVisibility('pair-delete-button', 'visible')
        }
    }
</script>